import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import RemoveRedEyeOutlined from '@mui/icons-material/RemoveRedEyeOutlined';
import { Button, TableCell } from '@mui/material';

import type { CellProps } from 'src/components/survey/SurveySelectionPage/components/SurveyTableView/types';

import { styles } from './cell.styles';

export const SURVEY_TABLE_ADDITIONAL_INFORMATION_TEST_ID =
  'survey-table-additional-information';

const AdditionalInformationCell: FC<CellProps> = ({ columns, survey }) => {
  const { t } = useTranslation('survey');
  const handleViewPdf = () =>
    window.open(survey.additionalInformation ?? '', '_blank', 'noreferrer');

  if (!columns.additionalInformation) return null;

  return (
    <TableCell sx={styles.cell(columns.additionalInformation.width)}>
      {!!survey.additionalInformation && (
        <Button
          variant="text"
          startIcon={<RemoveRedEyeOutlined />}
          sx={styles.textButton}
          onClick={handleViewPdf}
          data-test-id={SURVEY_TABLE_ADDITIONAL_INFORMATION_TEST_ID}
        >
          {t('view')}
        </Button>
      )}
    </TableCell>
  );
};

export default AdditionalInformationCell;
